 
import AuthorImg2 from "../../../assets/images/authorImg2.png";

// Example profiles data
export const similarProfiles = [
  {
    id: "9",
    badge: "Highly Rated Expert",
    location: "Indian",
    rate: 120,
    description: "(Dr.) Prakash Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic",
    rating: 4,
    image: AuthorImg2,
    name: "Dr. Ram Kumar",
    title: "Vice Chancellor | Supply Chain & Operations Expert",
    tags: [
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
    ],
  },
{
    id: "8",
    badge: "Highly Rated Expert",
    location: "Indian",
    rate: 120,
    description: "(Dr.) Prakash Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic",
    rating: 4,
    image: AuthorImg2,
    name: "Dr. Ram Kumar",
    title: "Vice Chancellor | Supply Chain & Operations Expert",
    tags: [
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
    ],
  },
  {
    id: "10",
    badge: "Highly Rated Expert",
    location: "Indian",
    rate: 120,
    description: "(Dr.) Prakash Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic",
    rating: 4,
    image: AuthorImg2,
    name: "Dr. Ram Kumar",
    title: "Vice Chancellor | Supply Chain & Operations Expert",
    tags: [
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
    ],
  },
  {
    id: "11",
    badge: "Highly Rated Expert",
    location: "Indian",
    rate: 120,
    description: "(Dr.) Prakash Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic Divakaran is a distinguished academic",
    rating: 4,
    image: AuthorImg2,
    name: "Dr. Ram Kumar",
    title: "Vice Chancellor | Supply Chain & Operations Expert",
    tags: [
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
      "Business",
      "Engineering",
      "Economics",
      "Technology, & Data",
      "Economics",
      "Technology, & Data",
    ],
  } ];
 